
export class UserSummaryModel {
  id: string;
  tenantId: string;
  fullName: string;
  email: string;
}
